import React, { useRef, useEffect, useState } from "react";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/css/froala_editor.pkgd.min.css";
import { froalaEditor } from "./FroalaConfig";
import "../styles/components/FroalaEditorrsd.scss";
import "../styles/components/CommonFroalEditorComponent.scss";
import "../../src/common.scss";

const FroalaEditorRSD = (props) => {
  const editorRef = useRef(null);
  const [editorInstance, setEditorInstance] = useState(null);
  const [editorContent, setEditorContent] = useState(props.defaultText || "");

  useEffect(() => {
    setEditorContent(props.defaultText || "");
  }, [props.defaultText]);

  const handleModelChange = (newText) => {
    if (newText !== editorContent) {
      setEditorContent(newText);
      props.handleModelChange(newText);
    }
  };

  useEffect(() => {
    if (editorInstance) {
      if (props.isDisabled) {
        editorInstance.edit.off();
      } else {
        editorInstance.edit.on();
      }
    }
  }, [props.isDisabled, editorInstance]);

  const froalaConfig = {
    ...froalaEditor.config({
      placeHolder: props.placeHolder,
      shouldHaveToolbar: true,
      shouldUpdateImmediatly: props.shouldUpdateImmediatly || false,
      contentEditable: props.editable !== "off",
      showToolBar: props.showToolBar,
    }),
    events: {
      initialized: function () {
        setEditorInstance(this);
      },
    },
  };

  return (
    <div
      className={`${props.className || "froalaContent"}`}
      style={{ paddingRight: props.scrollBarStyleWidth }}
    >
      {props.title && <p className="mb-0 box-heading">{props.title}</p>}
      <FroalaEditor
        ref={editorRef}
        className="common-editor"
        tag="textarea"
        config={froalaConfig}
        model={editorContent}
        onModelChange={handleModelChange}
        placeholder={props.placeHolder}
      />
    </div>
  );
};

export default FroalaEditorRSD;
